import React from 'react';

import buildingWallColorSetOffIcon from 'assets/building-wall-color-set-off.svg';
import buildingWallColorSetOnIcon from 'assets/building-wall-color-set-on.svg';

const SidebarBuildingWallColorIcon = ({
  active,
  className,
  id,
  onClick,
}: {
  active: boolean;
  className?: string;
  id?: string;
  onClick: () => void;
}): JSX.Element => (
  <img
    alt="building-wall-color-icon"
    className={className}
    id={id}
    onClick={onClick}
    src={active ? buildingWallColorSetOffIcon : buildingWallColorSetOnIcon}
  />
);

export default SidebarBuildingWallColorIcon;
